export const HEAD_FAVICON = {
  'pt-BR': {
    rel: 'shortcut icon',
    href: 'https://cozy-assets.quintoandar.com.br/cozy-static/v1/latest/favicon/favicon.ico',
  },
};
